import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Meet Monica", href: "#meet-monica" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
      style={{
        background: scrolled ? "rgba(250,249,246,0.85)" : "transparent",
        backdropFilter: scrolled ? "blur(14px)" : "none",
        borderBottom: scrolled ? "1px solid var(--border-soft)" : "1px solid transparent",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span
            className="font-serif-display text-2xl md:text-[28px] leading-none tracking-tight"
            style={{ color: "var(--text-main)" }}
          >
            Nourished Nest
          </span>
          <span
            className="text-[10px] tracking-[0.32em] uppercase pl-2 border-l"
            style={{ borderColor: "var(--gold)", color: "var(--gold)" }}
          >
            Doula
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm tracking-wide transition-colors"
              style={{ color: "var(--text-muted)" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "var(--blush-hover)")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "var(--text-muted)")}
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="nav-book-btn"
            onClick={() => document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })}
            className="rounded-full px-6 h-10 transition-transform hover:scale-105"
            style={{ background: "var(--blush)", color: "#FAF9F6" }}
          >
            Book Consultation
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} color="var(--text-main)" /> : <Menu size={22} color="var(--text-main)" />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden mt-3 mx-4 rounded-2xl p-6 flex flex-col gap-4"
          style={{ background: "var(--bg-tertiary)", border: "1px solid var(--border-soft)" }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm"
              style={{ color: "var(--text-main)" }}
            >
              {l.label}
            </a>
          ))}
          <Button
            data-testid="mobile-book-btn"
            onClick={() => {
              setOpen(false);
              document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="rounded-full"
            style={{ background: "var(--blush)", color: "#FAF9F6" }}
          >
            Book Consultation
          </Button>
        </div>
      )}
    </nav>
  );
}
